import { resolveRoleCodeFromUserRoleSlot } from "./resolve-role-code-from-user-role-slot.js";

function isActiveUserRoleSlot(role) {
  if (!role || typeof role !== "object") {
    return false;
  }
  return Boolean(role.isinsert || role.islist);
}

export function getViewerRoleCodesFromLocalStorage() {
  try {
    const raw = localStorage.getItem("user_token");
    const user = raw ? JSON.parse(raw) : null;
    const fromArray = Array.isArray(user?.roles)
      ? user.roles
          .filter(isActiveUserRoleSlot)
          .map(resolveRoleCodeFromUserRoleSlot)
          .filter(Boolean)
      : [];
    const topLevel = [user?.role_code, user?.roleCode, user?.role]
      .map(resolveRoleCodeFromUserRoleSlot)
      .filter(Boolean);
    return new Set([...fromArray, ...topLevel]);
  } catch (_error) {
    return new Set();
  }
}
